
<app-title-component [data]="{name : 'Collaborateurs'}"></app-title-component>


  <mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
    
      <mat-card-header class="d-flex align-items-center justify-content-end p-3 border-bottom">
      <div class="mx-2 mt-4">
        <app-search-bar-component (searchBarValue)="applyFilter($event)"></app-search-bar-component>
      </div>
      <button class="btn-add px-4 py-4 fw-semibold" matTooltip="Nouveau collaborateur" (click)="openAddCollaborateurModal()" mat-flat-button color="primary">
        <mat-icon class="me-1">add</mat-icon>
        <span>Ajouter</span>
      </button>
    </mat-card-header>

    <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
      @if (loading) {
        <div class="table-loading-overlay d-flex align-items-center justify-content-center">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
      }

      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
          
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> ID </th>
            <td mat-cell *matCellDef="let row" data-label="ID" class="text-secondary small fw-medium"> {{row.id}} </td>
          </ng-container>

          <ng-container matColumnDef="logo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Logo </th>
            <td mat-cell *matCellDef="let row" data-label="Logo">
              <div class="logo-container">
                <img class="avatar-img" [src]="API_STORAGE + row.logo" alt="logo" (error)="$event.target.style.display='none'">
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="collaborateur">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Collaborateurs </th>
            <td mat-cell *matCellDef="let row" data-label="Collaborateurs" class="fw-semibold text-dark"> {{row.name}} </td>
          </ng-container>

          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Propriétaire </th>
            <td mat-cell *matCellDef="let row" data-label="Propriétaire"> {{row.owner}} </td>
          </ng-container>

          <ng-container matColumnDef="adresse">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> Adresse </th>
            <td mat-cell *matCellDef="let row" data-label="Adresse" class="text-muted"> {{row.adresse}} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sticky> État </th>
            <td mat-cell *matCellDef="let row" data-label="État">
              @if(row.disable){
                <span class="badge-status status-inactive">Désactivé</span>
              } @else {
                <span class="badge-status status-active">Actif</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef sticky class="text-end pe-4"> Actions </th>
            <td mat-cell *matCellDef="let row" class="text-end pe-3">
              <div class="d-inline-flex gap-1">
                <button (click)="onChange(row); $event.stopPropagation()" [matTooltip]="row.disable ? 'Débloquer' : 'Bloquer'" mat-icon-button [color]="row.disable ? 'accent' : 'primary'">
                  @if (row.disable) {
                    <mat-icon class="text-success">lock_open</mat-icon>
                  } @else {
                    <mat-icon class="text-warning">lock</mat-icon>
                  }
                </button>
                <button matTooltip="Modifier" (click)="openUpdate(row); $event.stopPropagation()" mat-icon-button color="primary">
                  <mat-icon class="text-muted-icon">edit</mat-icon>
                </button>
                <button matTooltip="Supprimer" (click)="confirm(row); $event.stopPropagation()" mat-icon-button color="warn">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable-row" [matTooltip]="'Détails du courtier ' + row.name" (click)="goToDetails(row)"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center py-5 text-muted" colspan="7">Aucune donnée ne correspond au filtre "{{searchValue()}}"</td>
          </tr>
          </table>
      </div> 
    </mat-card-content>

    <div class="border-top bg-white">
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Sélectionner la page"></mat-paginator>
    </div>
  </mat-card>



